import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  return (
    <div className="flex min-h-screen bg-[#FBFBF9]">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <Outlet />
        <Toaster position="top-right" richColors />
      </main>
    </div>
  );
}
